module.exports = __webpack_public_path__ + "img/brand_Chelsea.5c33c390.png";